/**
******************************************************************
* Written by: Dana Moshe
******************************************************************
*/
export enum LogicFilter {
	// The enum element must be in the same order in the server!!!!!!!!!!!!!!!
	and, or
}

export enum OperatorFilter {
	// The enum element must be in the same order in the server!!!!!!!!!!!!!!!
	eq, neq, gte, gt, lte, lt, startswith, endswith,
	contains, notcontains, all, none, autoSuggest
}

export interface ILookupFilter {
}

export interface IBaseFilter extends ILookupFilter {

	operator:OperatorFilter;

	field:string;

	value:any;

	/**
	* String case invariant (if this value is true
	* this is not matter lowercase or uppercase).
	*/
	isCaseInvariant?:boolean;
}

export interface IComplexFilter extends ILookupFilter {

	logic:LogicFilter;
	valueForFilters?:any;// use this property to shorten the URL if we use the same value for all filters
	operatorForFilters?:OperatorFilter;
	isCaseInvariantForFilters?:boolean;
	filters:ILookupFilter[];
}

export  function instanceOfIComplexFilter(object:any): object is IComplexFilter{
	// no support for object=undefined. not sure what would be best
	return "filters" in object && "logic" in object;
}
